export const event = (eventName) => {
  if (window.ttq) {
    if (eventName) {
      window.ttq.track(eventName);
    } else {
      console.log('Event is missing:', { eventName });
    }
  } else {
    console.log('window.ttq is missing. event not tracked: ', {
      eventName,
    });
  }
};
